import { DRAGONBONES_PATH } from './Dragonbones';
import { PetArmature } from '../Utility/Helpers/Pets/PetArmature';
import { PetAnimations } from '../Utility/Helpers/Pets/PetAnimations';
import { IPetAnimationData } from '../Utility/Helpers/Pets/IPetAnimationData';
import { IPetData } from '../Utility/Helpers/Pets/IPetData';
import Point from '../Utility/Point';

export enum PetId {
    Charly = 'charly',
}

export const PET_ANIMATION_PATH: string = `${DRAGONBONES_PATH}/Pets/`;

export const PetAnimationData: Record<PetAnimations, IPetAnimationData> = {
    [PetAnimations.IDLE]: {
        armatureName: PetArmature.IDLE,
        animationName: 'sitting',
        possibleAnimations: [
            PetAnimations.IDLE_TO_WALKING,
            PetAnimations.IDLE,
            PetAnimations.DIGGING,
            PetAnimations.IDLE_CLICK,
            PetAnimations.IDLE_CLICK_2,
        ],
    },
    [PetAnimations.IDLE_CLICK]: {
        armatureName: PetArmature.IDLE,
        animationName: 'click',
        possibleAnimations: [PetAnimations.IDLE],
    },
    [PetAnimations.IDLE_CLICK_2]: {
        armatureName: PetArmature.IDLE,
        animationName: 'click_2',
        possibleAnimations: [PetAnimations.IDLE],
    },
    [PetAnimations.WALKING]: {
        armatureName: PetArmature.WALKING,
        animationName: 'animation',
        possibleAnimations: [PetAnimations.IDLE_TO_WALKING, PetAnimations.WALKING],
    },
    [PetAnimations.DIGGING]: {
        armatureName: PetArmature.DIGGING,
        animationName: 'animation',
    },
    [PetAnimations.IDLE_TO_WALKING]: {
        armatureName: PetArmature.IDLE_TO_WALKING,
        animationName: 'sitting',
        possibleAnimations: [PetAnimations.WALKING],
    },
    [PetAnimations.WALKING_TO_IDLE]: {
        armatureName: PetArmature.WALKING_TO_IDLE,
        animationName: 'sitting',
        possibleAnimations: [PetAnimations.IDLE],
    },
    [PetAnimations.MINI_GAME_HUNGRY]: {
        armatureName: PetArmature.MINI_GAME_HUNGRY,
        animationName: 'animation',
        possibleAnimations: [PetAnimations.MINI_GAME_FED],
    },
    [PetAnimations.MINI_GAME_FED]: {
        armatureName: PetArmature.MINI_GAME_FED,
        animationName: 'animation',
        possibleAnimations: [PetAnimations.MINI_GAME_HUNGRY],
    },
    [PetAnimations.HUNGRY]: {
        armatureName: PetArmature.MY_FARM,
        animationName: PetAnimations.HUNGRY,
        possibleAnimations: [PetAnimations.FALLING_ASLEEP],
    },
    [PetAnimations.FALLING_ASLEEP]: {
        armatureName: PetArmature.MY_FARM,
        animationName: PetAnimations.FALLING_ASLEEP,
        possibleAnimations: [PetAnimations.SLEEPING],
    },
    [PetAnimations.SLEEPING]: {
        armatureName: PetArmature.MY_FARM,
        animationName: PetAnimations.SLEEPING,
        possibleAnimations: [PetAnimations.AWAKENING],
    },
    [PetAnimations.AWAKENING]: {
        armatureName: PetArmature.MY_FARM,
        animationName: PetAnimations.AWAKENING,
        possibleAnimations: [PetAnimations.MINI_GAME_HUNGRY],
    },
};

export const PetData: Record<PetId, IPetData> = {
    [PetId.Charly]: {
        nodeScale: new Point(0.42, 0.42),
        positionOffset: new Point(15, -55),
        nodeWalkOffset: new Point(0, 5),
        nodeWalkNextWorldOffset: new Point(1000, 5),
    },
};

export const nextPetLevelLimit = { minLimit: 4, maxLimit: 6 };

export enum PetFoodType {
    FISH = 'fish',
    DRY = 'dry',
    WET = 'wet',
}

export interface IPetFoodData {
    sprite: string;
    armatureName: string;
}

export const PetFoodData: Record<PetFoodType, IPetFoodData> = {
    [PetFoodType.DRY]: {
        sprite: 'pet_minigame_feed_1',
        armatureName: 'pet_food_1',
    },
    [PetFoodType.FISH]: {
        sprite: 'pet_minigame_feed_2',
        armatureName: 'pet_food_2',
    },
    [PetFoodType.WET]: {
        sprite: 'pet_minigame_feed_3',
        armatureName: 'pet_food_3',
    },
};
